import { Button, IconButton, Typography, Box, useTheme } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getButtonInteractionStyles } from './styles';

interface BackButtonProps {
  onClick: () => void;
  variant: 'full' | 'compact';
}

export const BackButton = ({ onClick, variant }: BackButtonProps) => {
  const theme = useTheme();
  const interactionStyles = getButtonInteractionStyles(theme);

  if (variant === 'full') {
    return (
      <Button
        variant="text"
        onClick={onClick}
        sx={{
          gap: '8px',
          height: '44px',
          width: '115px',
          padding: '12px 24px',
          boxSizing: 'border-box',
          color: theme.palette.neutralGrey[950],
          ...interactionStyles,
        }}
      >
        <ArrowBackIcon sx={{ fontSize: '20px' }} />
        <Typography
          sx={{
            display: { xs: 'none', sm: 'flex' },
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            textAlign: 'center',
          }}
        >
          Back
        </Typography>
      </Button>
    );
  }

  // Compact variant: icon button + text (for signing up flow)
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <IconButton
        onClick={onClick}
        id="backButton"
        sx={{
          border: `1px solid ${theme.palette.neutralGrey[950]}`,
          mr: 2,
          ...interactionStyles,
        }}
      >
        <ArrowBackIcon sx={{ color: theme.palette.neutralGrey[950], fontSize: '20px' }} />
      </IconButton>
      <Typography
        onClick={onClick}
        sx={{
          display: { xs: 'none', sm: 'flex' },
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '24px',
          textAlign: 'center',
        }}
      >
        Back
      </Typography>
    </Box>
  );
};
